import { withInstall } from '@lit-element/utils'

import Pagination from './src/pagination'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtPagination: SFCWithInstall<typeof Pagination> =
  withInstall(Pagination)
export default LtPagination

export * from './src/pagination'
export * from './src/constants'
